/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { PlusModalData } from "~/common/PlusSubscriptionModal/Models";

const fetchPlusModalData = async (): Promise<Throwable<PlusModalData>> => {
  try {
    const url = new URL(`/api/plussignup/`, window.location.origin);
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.status === 404) {
      const error = new Error("Error getting Plus Modal data");
      return { isError: true, error };
    }
    const data = await response.json<string>();
    return { isError: false, value: (data as unknown) as PlusModalData };
  } catch (error) {
    return { isError: true, error: toError(error) };
  }
};

export default fetchPlusModalData;
